/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Screens_DeskInputs */

const en_onboarding_screens_desk = /** @type {(inputs: Onboarding_Screens_DeskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitting at a desk is tiring`)
};

const es_onboarding_screens_desk = /** @type {(inputs: Onboarding_Screens_DeskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estar sentado en un escritorio es agotador`)
};

/**
* | output |
* | --- |
* | "Sitting at a desk is tiring" |
*
* @param {Onboarding_Screens_DeskInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_screens_desk = /** @type {((inputs?: Onboarding_Screens_DeskInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Screens_DeskInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_screens_desk(inputs)
	return en_onboarding_screens_desk(inputs)
});